import {ON_COOKIE_OPENED, ON_COOKIE_CLOSED, ON_COOKIE_ACCEPTED, ON_COOKIE_DECLINED} from './events';
import dispatchEvent from './dispatchEvents';

const COOKIE_VARIABLE = 'cookie_consent';
const COOKIE_DATE_TIME = 'cookie_time';
const COOKIE_ACCEPTED = 200;
const COOKIE_DECLINED = 400;
const REMEMBER_DAYS = 7;

export default () => {

    const popup = document.querySelector('[data-cookie]');
    const icon = document.querySelector('[data-cookie-icon]');
    const btnAccept = document.querySelector('[data-cookie-accept]');
    const btnDecline = document.querySelector('[data-cookie-decline]');

    // check null pointer first
    if (!popup) {
        return;
    }

    function isAccepted()
    {
        const now = getTime();
        const date = window.localStorage.getItem(COOKIE_DATE_TIME);
        const cookieData = parseInt(window.localStorage.getItem(COOKIE_VARIABLE));
        if (cookieData && date) {
            const diff = (now - date) / (1000 * 3600 * 24);
            return cookieData === COOKIE_ACCEPTED
                && diff <= REMEMBER_DAYS;
        }
        return false;
    }

    function hasResponded()
    {
        const now = getTime();
        const date = window.localStorage.getItem(COOKIE_DATE_TIME);
        if (date) {
            const diff = (now - date) / (1000 * 3600 * 24);
            return diff <= REMEMBER_DAYS;
        }
        return false;
    }

    function openPopup()
    {
        popup.classList.add('gdpr--active');
        dispatchEvent(ON_COOKIE_OPENED);
    }

    function closePopup()
    {
        popup.classList.remove('gdpr--active');
        dispatchEvent(ON_COOKIE_CLOSED);
    }

    function isPopupOpened()
    {
        return popup.classList.contains('gdpr--active');
    }

    function getTime()
    {
        return Date.now();
    }


    function updatedText()
    {
        const acceptLabel = btnAccept.getAttribute('data-cookie-btn');
        const acceptedLabel = btnAccept.getAttribute('data-cookie-accepted');
        if (isAccepted()) {
            btnAccept.innerHTML = acceptedLabel;
        } else {
            btnAccept.innerHTML = acceptLabel;
        }
    }


    icon.addEventListener('click', (e) => {
        e.preventDefault();
        if (isPopupOpened()) {
            closePopup();
        } else {
            openPopup();
        }
        return false;
    });

    btnAccept.addEventListener('click', (e) => {
        e.preventDefault();
        window.localStorage.setItem(COOKIE_VARIABLE, COOKIE_ACCEPTED);
        window.localStorage.setItem(COOKIE_DATE_TIME, getTime());
        dispatchEvent(ON_COOKIE_ACCEPTED);
        closePopup();
        updatedText();
        return false;
    });

    btnDecline.addEventListener('click', (e) => {
        e.preventDefault();
        window.localStorage.setItem(COOKIE_VARIABLE, COOKIE_DECLINED);
        window.localStorage.setItem(COOKIE_DATE_TIME, getTime());
        dispatchEvent(ON_COOKIE_DECLINED);
        closePopup();
        updatedText();
        return false;
    });

    window.isCookieAccepted = isAccepted;

    window.addEventListener('load', () => {

        if (!hasResponded()) {
            openPopup();
        }

        if (isAccepted()) {
            dispatchEvent(ON_COOKIE_ACCEPTED);
        }

        updatedText();

    });

}

